export const scrollToHash = (baseDuration = 100) => {
    const hash = window.location.hash;
    if (hash) {
        const element = document.querySelector(hash);
        if (element) {
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
            const currentPosition = window.scrollY;
            const distance = Math.abs(elementPosition - currentPosition);
            const duration = Math.min(baseDuration + distance * 0.5, 2000); // Adjust duration based on distance

            setTimeout(() => {
                window.scrollTo({
                    top: elementPosition,
                    behavior: "smooth",
                    duration: duration
                });
            });
        }
    }
};
